import { render, staticRenderFns } from "./Restricao.vue?vue&type=template&id=033496d4&scoped=true"
import script from "./Restricao.vue?vue&type=script&lang=js"
export * from "./Restricao.vue?vue&type=script&lang=js"
import style0 from "./Restricao.vue?vue&type=style&index=0&id=033496d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033496d4",
  null
  
)

export default component.exports